import React, { useEffect, useRef, useState } from 'react';
import Layout from '../Layout';
import { Image } from 'react-bootstrap';
import 'animate.css';

const Team = () => {

    const ref = useRef(null);
    const [inView, setInView] = useState(false);


    return (
        <Layout>


            <section className='pages-container'>
                <h1 className='carousel-text-h1 wow animate__ animate__fadeIn  animated' data-wow-duration="1.4s">Who We Are<br /></h1>
            </section>

            {/* Services Section */}
            <section className="section-container" style={{ paddingBottom: '0px' }}>
                <div className="services-section">
                    <h4 className="pageh4 mb-3 pagp  wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">The leadership of Bethel Community Foundation Canada blends deep community roots with extensive executive experience.</h4>
                    <div className="mb-4 w50">
                        <p className=" mb-4 mx-auto text-center wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">
                            Whether through outreach programs, support services, or community development initiatives, our commitment is rooted in compassion, inclusivity, and actionable change.
                        </p>
                    </div>
                </div>
            </section>


            <section className="section-container" style={{ paddingTop: '0px' }}>
                <div className=' wow animate__animated animate__fadeInUp' data-wow-duration="1s">
                    <Image src="/images/team.png" alt="Hero" className="img-fluid box-img  wow animate__animated animate__fadeInUp" data-wow-duration="1.2s" />
                    <div className='secTwo'>
                        <p className="paragraph-title wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">Together, these seasoned leaders uphold our values and ensure our impact reaches those who need it most.</p>
                    </div>
                </div>
            </section>

            <section className="section-container">
                <div className="">
                    <h2 className="h4 mb-3 wow animate__animated animate__fadeInUp" data-wow-duration="1s">Board Members and Management Profile</h2>
                    {/* <div className="w50"> */}
                        <p className="mx-auto wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">Our Board & Management is composed of dedicated individuals committed to public service<br />  and community development:</p>
                    {/* </div> */}
                </div>
                <div className="team-imgBox">
                    <div className='team-img wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        {/* <div className=""> */}
                             <Image src="/images/lucky_braimoh.jpeg" alt="Lucky Braimoh" className="img-fluid" />
                             <div className="team-text">
                                <p className="team-name">Dr. Lucky Braimoh</p>
                                <p className="team-sub">Board Chairman</p>
                            </div>
                        {/* </div> */}
                    </div>
                    <div className='team-img wow animate__animated animate__fadeInUp' data-wow-duration="1.5s">
                        <Image src="/images/edith_braimoh.jpeg" alt="Edith Braimoh" className="img-fluid" />
                             <div className="team-text">
                                <p className="team-name">Edith Braimoh</p>
                                <p className="team-sub">Director</p>
                            </div>
                    </div>
                    <div className='team-img wow animate__animated animate__fadeInUp' data-wow-duration="1.8s">
                        <Image src="/images/lucky_momoh.jpeg" alt="Lucky Momoh" className="img-fluid" />
                             <div className="team-text">
                                <p className="team-name">Lucky Momoh</p>
                                <p className="team-sub">Director</p>
                            </div>
                    </div>
                     <div className='team-img wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/anavami_braimoh.png" alt="Anavami Braimoh" className="img-fluid" />
                             <div className="team-text">
                                <p className="team-name">Anavami Braimoh</p>
                                <p className="team-sub">Director</p>
                            </div>
                    </div>
                    <div className='team-img wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/shilla_marie.jpeg" alt="Shiella Marie Atienza" className="img-fluid" />
                             <div className="team-text">
                                <p className="team-name">Architect Shiella Marie Atienza</p>
                                <p className="team-sub">Board Secretary</p>
                            </div>
                    </div>
                   
                     <div className='team-img wow animate__animated animate__fadeInUp' data-wow-duration="1.2s">
                        <Image src="/images/emmanuel_ojemade.jpeg" alt="Emmanuel Ojemade" className="img-fluid" />
                             <div className="team-text">
                                <p className="team-name">Emmanuel Ojemade</p>
                                <p className="team-sub">Executive Director</p>
                            </div>
                    </div>
                </div>
            </section>


        </Layout>
    );
};

export default Team;